<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-database-settings</v-icon>
            Master Data Management
          </v-card-title>
          <v-card-text>
            <!-- Navigation Tabs -->
            <v-tabs v-model="activeTab" class="mb-4">
              <v-tab>
                <v-icon left>mdi-currency-usd</v-icon>
                Billing Rates
              </v-tab>
              <v-tab>
                <v-icon left>mdi-tag-multiple</v-icon>
                Cost Categories
              </v-tab>
              <v-tab>
                <v-icon left>mdi-cog-outline</v-icon>
                App Config
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <router-view />
              </v-tab-item>
              <v-tab-item>
                <cost-category-list />
              </v-tab-item>
              <v-tab-item>
                <app-config-management />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CostCategoryList from '../components/categories/CostCategoryList.vue';
import AppConfigManagement from '../components/config/AppConfigManagement.vue';

export default {
  name: 'MasterData',
  components: {
    CostCategoryList,
    AppConfigManagement,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
